import { MinHeap } from "@datastructures-js/heap";

export type Edge = {
    start: string;
    end: string;
    cost: number;
};

export type Node = {
    identifier: string;
    edges: Edge[];
};

export type HeapNode = {
    travelCost: number;
    identifier: string;
    parent: string | undefined | null;
};

export const getCost = (aPos: { x: number; y: number }, bPos: { x: number; y: number }) => {
    const dx = aPos.x - bPos.x;
    const dy = aPos.y - bPos.y;

    return Math.sqrt(dx * dx + dy * dy);
};

export const getShortestPath = (startId: string, endId: string, nodes: Record<string, Node>): string[] | null => {
    const minHeap = new MinHeap<HeapNode>((val) => val.travelCost, undefined);

    const parentNode: Record<string, string | undefined | null> = {};

    minHeap.push({ identifier: startId, travelCost: 0, parent: null });

    while (!minHeap.isEmpty()) {
        const curNodeId = minHeap.pop()!;
        if (parentNode[curNodeId.identifier] !== undefined) continue;

        parentNode[curNodeId.identifier] = curNodeId.parent;

        if (curNodeId.identifier === endId) break;

        const curNode = nodes[curNodeId.identifier];

        for (const edge of curNode.edges) {
            minHeap.push({ identifier: edge.end, travelCost: curNodeId.travelCost + edge.cost, parent: edge.start });
        }
    }

    if (parentNode[endId] === undefined) return null;

    const path: string[] = [];

    let curId: string | undefined | null = endId;
    while (curId !== null) {
        path.push(curId!);
        curId = parentNode[curId!];
    }

    path.reverse();

    return path;
};
